import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { LanguageService } from '@fcom/ui-translate';
import { RootPaths } from '@fcom/core/constants';

import { OndMarketingRoutesPath } from '../../interfaces';

@Component({
  selector: 'fin-ond-marketing-ribbon',
  templateUrl: './ond-marketing-ribbon.component.html',
  styleUrls: ['./ond-marketing-ribbon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OndMarketingRibbonComponent {
  private languageService = inject(LanguageService);

  private readonly lang = `/${this.languageService.langValue}/`;

  readonly links: string[] = Object.values(OndMarketingRoutesPath).map(
    (item) => `${this.lang}${RootPaths.OND_MARKETING_LANDING_ROOT}/${item}`
  );
  readonly linkTranslationKeys: string[] = ['from', 'fromCountry', 'cityToCity', 'countryToCountry'];
}
